import { render, staticRenderFns } from "./TextNoteContentForm.vue?vue&type=template&id=64c7fd62&"
import script from "./TextNoteContentForm.vue?vue&type=script&lang=js&"
export * from "./TextNoteContentForm.vue?vue&type=script&lang=js&"
import style0 from "./TextNoteContentForm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports